export interface GiftItem {
  id: string;
  name: string;
  value: number;
  image: string;
  /** Voliteľná kategória pre filtrovanie na stránke /darceky */
  category?: string;
  /** Voliteľné varianty (veľkosť, farba…) — zákazník musí jeden zvoliť */
  variants?: string[];
  /** Popis skupiny variantov, napr. „Veľkosť“ */
  variantLabel?: string;
}

export interface GiftTier {
  id: string;
  threshold: number;
  label: string;
  gifts: GiftItem[];
}

const img = (id: string) =>
  `https://images.unsplash.com/photo-${id}?w=400&h=400&fit=crop`;

/** Darčekové méty — po prekročení sumy si zákazník vyberie 1 darček z danej méty. */
export const giftTiers: GiftTier[] = [
  {
    id: "t1",
    threshold: 30,
    label: "Darček od 30 €",
    gifts: [
      { id: "g1", name: "MERCH samolepky (set 5 ks)", value: 3.9, image: img("1626785774573-4b799315345d"), category: "Doplnky" },
      { id: "g2", name: "Plátenná taška MERCH", value: 6.9, image: img("1591561954557-26941169b49e"), category: "Tašky" },
      { id: "g3", name: "Odznak MERCH (set 3 ks)", value: 4.5, image: img("1513542789411-b6a5d4f31634"), category: "Doplnky" },
      { id: "g4", name: "Kľúčenka MERCH", value: 5.9, image: img("1622560480605-d83c853bc5c3"), category: "Doplnky" },
      { id: "g5", name: "Zápisník MERCH A6", value: 6.5, image: img("1531346878377-a5be20888e57"), category: "Papiernictvo" },
      { id: "g6", name: "Ceruzka + pero set", value: 4.9, image: img("1455390582262-044cdead277a"), category: "Papiernictvo" },
      { id: "g7", name: "Magnetka MERCH", value: 3.5, image: img("1513542789411-b6a5d4f31634"), category: "Doplnky" },
      { id: "g8", name: "Vreckovka / bandana", value: 7.9, image: img("1520903920243-00d872a2d1c9"), category: "Textil", variantLabel: "Farba", variants: ["Čierna", "Biela", "Ružová"] },
      { id: "g9", name: "Náramok MERCH", value: 4.9, image: img("1515562141207-7a88fb7ce338"), category: "Doplnky" },
      { id: "g10", name: "Pohľadnica set (10 ks)", value: 5.5, image: img("1587614382346-4ec70e388b28"), category: "Papiernictvo" },
    ],
  },
  {
    id: "t2",
    threshold: 60,
    label: "Darček od 60 €",
    gifts: [
      { id: "g11", name: "Ponožky MERCH Classic", value: 8.9, image: img("1586350977771-b3b0abd50c82"), category: "Textil", variantLabel: "Veľkosť", variants: ["36-39", "40-43", "44-47"] },
      { id: "g12", name: "Šiltovka MERCH", value: 14.9, image: img("1588850561407-ed78c282e89b"), category: "Čiapky" },
      { id: "g13", name: "Termohrnček MERCH", value: 12.9, image: img("1514228742587-6b1558fcca3d"), category: "Domácnosť" },
      { id: "g14", name: "Keramický hrnček MERCH", value: 9.9, image: img("1517256064527-09c73fc73e38"), category: "Domácnosť" },
      { id: "g15", name: "Fľaša na vodu 500 ml", value: 13.9, image: img("1602143407151-7111542de6e8"), category: "Domácnosť" },
      { id: "g16", name: "Zimná čiapka MERCH", value: 12.9, image: img("1576871337622-98d48d1cf531"), category: "Čiapky", variantLabel: "Farba", variants: ["Čierna", "Sivá", "Ružová"] },
      { id: "g17", name: "Puzdro na mobil", value: 11.9, image: img("1592286927505-1def25115558"), category: "Doplnky" },
      { id: "g18", name: "Peňaženka MERCH", value: 14.5, image: img("1627123424574-724758594e93"), category: "Doplnky" },
      { id: "g19", name: "Uterák MERCH", value: 13.5, image: img("1600369672770-985fd30004eb"), category: "Textil" },
      { id: "g20", name: "Podložka pod myš XL", value: 10.9, image: img("1615663245857-ac93bb7c39e7"), category: "Gaming" },
    ],
  },
  {
    id: "t3",
    threshold: 100,
    label: "Darček od 100 €",
    gifts: [
      { id: "g21", name: "Mikina MERCH Essentials", value: 39.9, image: img("1556821840-3a63f95609a7"), category: "Textil", variantLabel: "Veľkosť", variants: ["S", "M", "L", "XL", "XXL"] },
      { id: "g22", name: "Športová taška MERCH", value: 34.9, image: img("1553062407-98eeb64c6a62"), category: "Tašky" },
      { id: "g23", name: "Ruksak MERCH Daily", value: 44.9, image: img("1553062407-98eeb64c6a62"), category: "Tašky" },
      { id: "g24", name: "Tričko MERCH Premium", value: 24.9, image: img("1521572163474-6864f9cf17ab"), category: "Textil", variantLabel: "Veľkosť", variants: ["S", "M", "L", "XL"] },
      { id: "g25", name: "Bluetooth reproduktor", value: 49.9, image: img("1608043152269-423dbba4e7e1"), category: "Elektronika" },
      { id: "g26", name: "Slúchadlá MERCH Sound", value: 45.9, image: img("1505740420928-5e560c06d30e"), category: "Elektronika" },
      { id: "g27", name: "Powerbanka 10 000 mAh", value: 29.9, image: img("1609091839311-d5365f9ff1c5"), category: "Elektronika" },
      { id: "g28", name: "Vesta MERCH Outdoor", value: 42.9, image: img("1591047139829-d91aecb6caea"), category: "Textil" },
      { id: "g29", name: "Deka MERCH Cozy", value: 32.9, image: img("1584100936595-c0654b55a2e6"), category: "Domácnosť" },
      { id: "g30", name: "Darčeková sada MERCH Box", value: 54.9, image: img("1549465220-1a8b9238cd48"), category: "Sady" },
    ],
  },
];

export const allGifts: GiftItem[] = giftTiers.flatMap((t) => t.gifts);

export const formatPrice = (value: number, currency = "€") =>
  `${value.toFixed(2).replace(".", ",")} ${currency}`;

export interface BonusProductItem {
  id: string;
  name: string;
  originalPrice: number;
  discountedPrice: number;
  image: string;
  discount: string;
  hasVariants?: boolean;
  slug?: string;
  variants?: string[];
  variantLabel?: string;
}

/** Zvýhodnené (bonusové) produkty k nákupu — platené, so zľavou. */
export const bonusProducts: BonusProductItem[] = [
  {
    id: "b1",
    name: "Prémiové bavlnené ponožky",
    originalPrice: 8.99,
    discountedPrice: 4.99,
    image: img("1586350977771-b3b0abd50c82"),
    discount: "-45%",
    hasVariants: false,
  },
  {
    id: "b2",
    name: "Kožený opasok Classic",
    originalPrice: 24.99,
    discountedPrice: 14.99,
    image: img("1553062407-98eeb64c6a62"),
    discount: "-40%",
    hasVariants: true,
    slug: "kozeny-opasok-classic",
    variantLabel: "Veľkosť",
    variants: ["85 cm", "90 cm", "95 cm", "100 cm"],
  },
  {
    id: "b3",
    name: "Šiltovka Urban Style",
    originalPrice: 19.99,
    discountedPrice: 12.99,
    image: img("1588850561407-ed78c282e89b"),
    discount: "-35%",
    hasVariants: true,
    slug: "siltovka-urban-style",
    variantLabel: "Farba",
    variants: ["Čierna", "Biela", "Ružová"],
  },
  {
    id: "b4",
    name: "Bavlnené tričko Basic",
    originalPrice: 14.99,
    discountedPrice: 9.99,
    image: img("1583743814966-8936f5b7be1a"),
    discount: "-33%",
    hasVariants: false,
  },
  {
    id: "b5",
    name: "Športová taška Compact",
    originalPrice: 34.99,
    discountedPrice: 19.99,
    image: img("1553062407-98eeb64c6a62"),
    discount: "-43%",
    hasVariants: false,
  },
  {
    id: "b6",
    name: "Termohrnček Travel",
    originalPrice: 22.99,
    discountedPrice: 13.99,
    image: img("1514228742587-6b1558fcca3d"),
    discount: "-39%",
    hasVariants: false,
  },
  {
    id: "b7",
    name: "Zimná čiapka Warm",
    originalPrice: 17.99,
    discountedPrice: 10.99,
    image: img("1576871337622-98d48d1cf531"),
    discount: "-39%",
    hasVariants: true,
    slug: "zimna-ciapka-warm",
    variantLabel: "Farba",
    variants: ["Čierna", "Sivá", "Béžová"],
  },
  {
    id: "b8",
    name: "Powerbanka Compact 10k",
    originalPrice: 39.99,
    discountedPrice: 24.99,
    image: img("1609091839311-d5365f9ff1c5"),
    discount: "-38%",
    hasVariants: false,
  },
];
